module.exports = __webpack_public_path__ + "img/shipments.ff3598ca.svg";